import { createSlice } from '@reduxjs/toolkit';

export const categoryList = createSlice({
  name: 'categoryList',
  initialState: {
    data: undefined,
  },

  reducers: {
    setCategoryList: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setCategoryList } = categoryList.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getCategoryList = (state) => {
  return state.categoryList.data;
};

export default categoryList.reducer;
